import { Breakpoint, ButtonType, UiComponentSize } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { i18n } from 'src/i18n';
import { arrowLeftImageProps } from 'src/resources/images';
import { NavigationService } from 'src/services/navigation-service';
import { BreadcrumbUtils } from 'src/utils/breadcrumbs-utils';
import { useLargeTabletMediaQuery } from 'src/utils/breakpoints-utils';

import {
  StyledArrowLeftIcon,
  StyledBreadcrumb,
  StyledButton,
  StyledContainer,
  StyledExternalLink,
  StyledLink,
  StyledLinkContainer,
  StyledText,
} from './breadcrumb.styled';

export const Breadcrumb: FC = () => {
  const path = useLocation().pathname;
  const { externalBreadcrumbs, internalBreadcrumbs } = BreadcrumbUtils.getBreadcrumbs(path);
  const navigate = useNavigate();
  const isOnLargeTablet = useLargeTabletMediaQuery();

  if (
    [NavigationService.SUCCESS].includes(path) ||
    (BreadcrumbUtils.isFirstInternalBreadcrumb(path) && !isOnLargeTablet)
  ) {
    return null;
  }

  const handleLogout = () => navigate(-1);

  const renderMobileBreadcrumbItems = () => (
    <StyledButton
      buttonType={ButtonType.TERTIARY}
      uiComponentSize={UiComponentSize.MEDIUM}
      onClick={handleLogout}
      iconWrapper={{
        icon: <StyledArrowLeftIcon {...arrowLeftImageProps} />,
        placeIconBeforeText: true,
      }}
    >
      {i18n.component.breadcrumbs.navigateBack}
    </StyledButton>
  );

  const renderDesktopBreadcrumbItems = () => (
    <>
      {externalBreadcrumbs.map((breadcrumb, index) => (
        <StyledLinkContainer key={index}>
          <StyledExternalLink variant="paragraph1" maxBreakpoint={Breakpoint.MOBILE} href={breadcrumb.path}>
            {breadcrumb.text}
          </StyledExternalLink>
        </StyledLinkContainer>
      ))}
      {internalBreadcrumbs.map((breadcrumb, index) => (
        <StyledLinkContainer key={index}>
          {internalBreadcrumbs.length - 1 === index ? (
            <StyledText variant="paragraph1" component="p" maxBreakpoint={Breakpoint.MOBILE}>
              {breadcrumb.text}
            </StyledText>
          ) : (
            <StyledLink to={breadcrumb.path}>{breadcrumb.text}</StyledLink>
          )}
        </StyledLinkContainer>
      ))}
    </>
  );

  return (
    <StyledBreadcrumb>
      <StyledContainer>
        {isOnLargeTablet ? renderDesktopBreadcrumbItems() : renderMobileBreadcrumbItems()}
      </StyledContainer>
    </StyledBreadcrumb>
  );
};
